import axios from 'axios';
import { useRouter } from 'next/router';
import qs from 'qs';
import type React from 'react';
import { useCallback, useState } from 'react';
import { UiKitButton } from '@components/common/ui-kit-button';
import { UiKitInput } from '@components/common/ui-kit-input';
import { ButtonGroup } from '@features/Unsubscribe/components/ButtonGroup';
import { Container } from '@features/Unsubscribe/components/Container';
import { Title } from '@features/Unsubscribe/components/Title';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import type { TpWizardSteps } from '@features/Unsubscribe/types';
import { WIZARD_STEPS } from '../../сonstants';
import styles from './Feedback.module.scss';
export const Feedback = (props: TpWizardSteps) => {
  const {
    wizard
  } = props;
  const {
    defaultEventOptions,
    trackUnsubscribeEvent
  } = useUnsubscribeAnalytics();
  const [value, setValue] = useState('');
  const [isInvalid, setIsInvalid] = useState(true);
  const {
    query
  } = useRouter();
  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
    event.target.value.length > 2 ? setIsInvalid(false) : setIsInvalid(true);
  }, []);
  const handleNext = useCallback(async () => {
    const formData = {
      message: value,
      from_label: 'Web cancel',
      form_name: 'Face Yoga',
      channel: '#cancellation',
      user_id: query?.user_id,
      user_email: query?.email,
      is_subscriber: true
    };
    try {
      await axios({
        method: 'post',
        url: `${process.env.NEXT_PUBLIC_API_MICROSERVICE_ENDPOINT}feedback`,
        data: qs.stringify(formData)
      });
      trackUnsubscribeEvent('cancel_help_us_tapped');
      wizard.goToStep(WIZARD_STEPS.LOTS_OF_NEW);
    } catch (error) {
      console.log(error);
    }
  }, [query?.email, query?.user_id, trackUnsubscribeEvent, value, wizard]);
  return <Container className={styles.container} eventOnMounted="cancel_help_us_opened" eventOptions={defaultEventOptions} data-sentry-element="Container" data-sentry-component="Feedback" data-sentry-source-file="index.tsx">
      <Title className={styles.title} data-sentry-element="Title" data-sentry-source-file="index.tsx">
        Please help us make Mimika better
        <br /> <span className="highlight">for everyone</span>
      </Title>

      <div className="double-grow">
        {/*// @ts-ignore*/}
        <UiKitInput fullWidth className={styles.textarea} as="textarea" rows={3} onChange={handleChange} value={value} placeholder="Define the cancellation reason here.
For example: I’m struggling to find
any free time and..." data-sentry-element="UiKitInput" data-sentry-source-file="index.tsx" />
      </div>

      <ButtonGroup data-sentry-element="ButtonGroup" data-sentry-source-file="index.tsx">
        <UiKitButton fullWidth onClick={handleNext} disabled={isInvalid} className={styles.button} data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
          Next
        </UiKitButton>
      </ButtonGroup>
    </Container>;
};